import { IDailyRentOfferForMobileSite } from '../../repositories/dailyrent/entities/daily_rent_offers_for_web/DailyRentOfferForMobileSite';
import { TAnalyticsPageType } from '../analytics';

export type TChatDates = { checkin: string; checkout: string };

export interface IBuildChatSrcParams {
  gaLabel?: string;
  dates: TChatDates | null;
  defaultMessage: string | null;
  pageType: TAnalyticsPageType;
}

export type TChatOffer = Pick<IDailyRentOfferForMobileSite, 'cianId' | 'dealType' | 'offerType'>;

export function buildChatSrc(
  offer: TChatOffer,
  { gaLabel, dates, defaultMessage, pageType }: IBuildChatSrcParams,
): string {
  const { cianId, dealType, offerType } = offer;

  return (
    `/dialogs/?hostType=frame&offerId=${cianId}` +
    `&dealType=${dealType}&offerType=${offerType}` +
    `${gaLabel ? '&gaLabel=' + encodeURIComponent(gaLabel) : ''}` +
    `&pageType=${pageType}` +
    `${defaultMessage ? '&defaultMessage=' + encodeURIComponent(defaultMessage) : ''}` +
    `${dates ? '&checkin=' + encodeURIComponent(dates.checkin) : ''}` +
    `${dates ? '&checkout=' + encodeURIComponent(dates.checkout) : ''}`
  );
}
